import React from "react";
import { Tab } from "@headlessui/react";
import { classNames } from "../../../../../helpers/functions";
import AMRMedicationList from "./AMRMedicationList";
import { drugTypes } from "../../service-steps/clinical-assessment/data";

const AMRPreReviewAdditionalMedicationsSection = ({
  filteredMedication,
  reviewedMedicationCards,
  showAdditionalMeds,
  setShowAdditionalMeds,
  onMedicationClick,
  onMenuAction,
  onExpandMedication,
  expandedMedications,
  hoveredMed,
  onMouseEnter,
  onMouseLeave,
  menuMedication,
  onMenuOpen,
  showMenu,
  menuData,
  selectedMedication,
  isMatchingDrug,
  medicationDetails,
  getNoRecordMessage,
  getCardFromDrug,
  selectMedication,
  medications = [],
  clinicalServiceObj = null,
}) => {
  const additionalMeds = medications.filter(
    (med) => med.medicationType === drugTypes.Additional && med.status === "active"
  );
  
  const reviewedMedNames = reviewedMedicationCards
    .filter((card) => card.status === "reviewed" || card.status === "skipped")
    .map((card) => card.name);
  
  const allMedicationsReviewed = additionalMeds.every((med) =>
    reviewedMedNames.includes(med.displayName)
  );
  
  // Completed state should reflect that additional medications themselves have been reviewed
  // and should NOT depend on the Additional Medication checklist card being completed.
  const isCompleted = additionalMeds.length > 0 && allMedicationsReviewed;

  return (
    <Tab.Group>
      <Tab.Panels className="">
        <Tab.Panel
          className={classNames(
            "rounded-xl bg-white",
            "ring-white ring-opacity-60 ring-offset-2 focus:outline-none focus:ring-2"
          )}
        >
          <AMRMedicationList
            filteredMedication={filteredMedication}
            reviewedMedicationCards={reviewedMedicationCards}
            medicationType={drugTypes.Additional}
            title="Additional Medications"
            isExpanded={showAdditionalMeds}
            onToggleExpanded={() => setShowAdditionalMeds(!showAdditionalMeds)}
            expandedMedications={expandedMedications}
            hoveredMed={hoveredMed}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            menuMedication={menuMedication}
            onMenuOpen={onMenuOpen}
            selectedMedication={selectedMedication}
            onExpandMedication={onExpandMedication}
            medicationDetails={medicationDetails}
            getNoRecordMessage={getNoRecordMessage}
            getCardFromDrug={getCardFromDrug}
            selectMedication={selectMedication}
            isCompleted={isCompleted}
          />
        </Tab.Panel>
      </Tab.Panels>
    </Tab.Group>
  );
};

export default AMRPreReviewAdditionalMedicationsSection;
